// extracted by mini-css-extract-plugin
export var site_main = "layout-module--site_main--e54fc";